import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { userActions } from '_actions';
import { notificationService } from '_services';
import styles from './LoginPage.module.css'
import { MsalContext } from "@azure/msal-react";
import { history } from '_helpers';
import { RouteDefs } from '_constants';

class LoginPage extends React.Component {
    static contextType = MsalContext;

    componentDidMount() {
        notificationService.stopService();
        this.setState((state) => {
            return { loading: false };
        })

    // When this component loads, clear the specific data so user can login. In case of multiple companies, we are not going to clear their local storage data.
   const companyId = sessionStorage.getItem('companyId');
   if(companyId !== null 
    && 
    companyId !== undefined )
    {
        localStorage.removeItem(`pterotoken_${companyId}`);
        localStorage.removeItem(`user_${companyId}`);
    }
    // This removal is required to get azure login
        localStorage.removeItem('user');
        localStorage.removeItem('pterotoken');

    }

    handleClick() {
        history.push(RouteDefs.autoLogin.path);
    }

    render() {
        return (
            <div className={styles.login_wrapper}>
                <img alt='CORA Physical Therapy' className={styles.logo} src='./images/cora_animated.gif'></img>
                <p><button className={styles.login_button} onClick={() => this.handleClick()}>Login</button></p>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        login: bindActionCreators(userActions.login, dispatch),
    };
}

const connectedLoginPage = connect(mapStateToProps, mapDispatchToProps)(LoginPage);
export { connectedLoginPage as LoginPage }; 